"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var tabel_cell_1 = require("../../../../../components/tabel_cell");
var table_bottom_content_1 = require("../../../../../components/table/tableBottomContent/table_bottom_content");
var tableContext_1 = require("../../../../../contexts/tableContext");
var delete_client_media_asset_thunk_1 = require("../../../../../reducers/slices/client/thunks/delete_client_media_asset_thunk");
var get_client_media_assets_thunk_1 = require("../../../../../reducers/slices/client/thunks/get_client_media_assets_thunk");
var main_1 = require("../../../../../reducers/slices/main");
var table_top_content_1 = require("../product_attribute_families/table_top_content");
var media_assets_grid_1 = require("./components/media_assets_grid");
var table_top_bar_1 = require("./components/table_top_bar");
var constants_1 = require("./constants");
var useColumns_1 = require("./hooks/useColumns");
var useFilterActions_1 = require("./hooks/useFilterActions");
var useMediaCategories_1 = require("./hooks/useMediaCategories");
var useMediaTags_1 = require("./hooks/useMediaTags");
var useRenderCellViews_1 = require("./hooks/useRenderCellViews");
var useRowActions_1 = require("./hooks/useRowActions");
var MediaAssetsTablePage = function (_a) {
    var _b = _a.layout, layout = _b === void 0 ? constants_1.LayoutType.LIST : _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, react_2.useState)(new Set()), selectedKeys = _c[0], setSelectedKeys = _c[1];
    var _d = (0, react_2.useState)(""), searchQuery = _d[0], setSearchQuery = _d[1];
    var _e = (0, react_2.useState)(""), typeFilter = _e[0], setTypeFilter = _e[1];
    var _f = (0, react_2.useState)(""), categoryFilter = _f[0], setCategoryFilter = _f[1];
    var _g = (0, react_2.useState)(""), tagFilter = _g[0], setTagFilter = _g[1];
    var _h = (0, react_2.useState)([]), categories = _h[0], setCategories = _h[1];
    var _j = (0, react_2.useState)([]), tags = _j[0], setTags = _j[1];
    var _k = (0, react_2.useState)(layout), tableLayout = _k[0], setTableLayout = _k[1];
    var _l = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }), mediaAssets = _l.mediaAssets, loading = _l.loading, pagination = _l.pagination;
    var renderCellViews = (0, useRenderCellViews_1.useRenderCellViews)().renderCellViews;
    var fetchMediaCategories = (0, useMediaCategories_1.useMediaCategories)().fetchMediaCategories;
    var fetchMediaTags = (0, useMediaTags_1.useMediaTags)().fetchMediaTags;
    var filterActions = (0, useFilterActions_1.useFilterActions)({ mediaAssets: mediaAssets }).filterActions;
    var _m = (0, useRowActions_1.useRowActions)(), rowActions = _m.rowActions, onSelectionChange = _m.onSelectionChange, selectedTableCells = _m.selectedTableCells;
    var _o = (0, useColumns_1.useColumns)(), columns = _o.columns, excludeSortColumns = _o.excludeSortColumns, headerColumns = _o.headerColumns, initialSortDescriptor = _o.initialSortDescriptor, onVisibleColumnsChanged = _o.onVisibleColumnsChanged, setTableColumnConfig = _o.setTableColumnConfig, tableColumnConfig = _o.tableColumnConfig, visibleColumns = _o.visibleColumns;
    (0, react_2.useEffect)(function () {
        loadMediaAssets();
        loadCategories();
        loadTags();
    }, []);
    var loadMediaAssets = function (query) {
        if (query === void 0) { query = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch((0, get_client_media_assets_thunk_1.get_client_media_assets_thunk)(__assign(__assign({}, query), pagination)));
                return [2 /*return*/];
            });
        });
    };
    var loadCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, formattedCategories;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchMediaCategories()];
                case 1:
                    response = _a.sent();
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        formattedCategories = response.content.categories.map(function (category) { return ({
                            value: category._id,
                            label: category.name,
                        }); });
                        setCategories(__spreadArray([{ value: "", label: "All Categories" }], formattedCategories, true));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var loadTags = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, formattedTags;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchMediaTags()];
                case 1:
                    response = _a.sent();
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        formattedTags = response.content.tags.map(function (tag) { return ({
                            value: tag._id,
                            label: tag.name,
                        }); });
                        setTags(__spreadArray([{ value: "", label: "All Tags" }], formattedTags, true));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch((0, delete_client_media_asset_thunk_1.delete_client_media_asset_thunk)({ _id: id }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onLayoutChanged = (0, react_2.useCallback)(function (layout) {
        setTableLayout(layout);
    }, []);
    var renderRowView = (0, react_2.useCallback)(function (id, value, mediaAsset) {
        var _a;
        if (!value)
            return;
        var columnKey = (_a = Object.keys(mediaAsset)) === null || _a === void 0 ? void 0 : _a.find(function (key) { return mediaAsset[key] === value; });
        return [{ key: columnKey, content: renderCellViews(columnKey, mediaAsset) }];
    }, []);
    var handleSelectionChange = (0, react_2.useCallback)(function (keys) {
        setSelectedKeys(new Set(Array.from(keys)));
    }, []);
    var showMediaUpload = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Select File",
            content: (0, jsx_runtime_1.jsx)(MediaAssetsTablePage, { layout: constants_1.LayoutType.GRID }),
        }));
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-4" }, { children: tableLayout === constants_1.LayoutType.GRID ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4 items-center mb-4" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Search media assets...", value: searchQuery, onChange: function (e) { return setSearchQuery(e.target.value); }, className: "w-64" }), (0, jsx_runtime_1.jsx)(react_1.Select, __assign({ label: "Type", placeholder: "Select type", selectedKeys: typeFilter ? [typeFilter] : [], onChange: function (e) { return setTypeFilter(e.target.value); }, className: "w-48" }, { children: constants_1.typeOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) })), (0, jsx_runtime_1.jsx)(react_1.Select, __assign({ label: "Category", placeholder: "Select category", selectedKeys: categoryFilter ? [categoryFilter] : [], onChange: function (e) { return setCategoryFilter(e.target.value); }, className: "w-48" }, { children: categories.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) })), (0, jsx_runtime_1.jsx)(react_1.Select, __assign({ label: "Tag", placeholder: "Select tag", selectedKeys: tagFilter ? [tagFilter] : [], onChange: function (e) { return setTagFilter(e.target.value); }, className: "w-48" }, { children: tags.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) }))] })), (0, jsx_runtime_1.jsx)(media_assets_grid_1.MediaAssetsGrid, { onDelete: handleDelete })] })) : ((0, jsx_runtime_1.jsxs)(tableContext_1.TableContextProvider, __assign({ columns: columns, defaultQueryParams: pagination, excludeSortColumns: excludeSortColumns, filterActions: filterActions, headerColumns: headerColumns, initialSortDescriptor: initialSortDescriptor, onPageChange: loadMediaAssets, onVisibleColumnsChanged: onVisibleColumnsChanged, setTableConfig: setTableColumnConfig, tableColumnConfig: tableColumnConfig, pagination: pagination, visibleColumns: visibleColumns, onLayoutChanged: onLayoutChanged }, { children: [(0, jsx_runtime_1.jsx)(table_top_bar_1.TableTopBar, { showMediaUpload: showMediaUpload }), (0, jsx_runtime_1.jsxs)(react_1.Table, __assign({ isHeaderSticky: true, "aria-label": "Products", bottomContent: (0, jsx_runtime_1.jsx)(table_bottom_content_1.TableBottomContent, {}), bottomContentPlacement: "outside", classNames: {
                        td: "before:bg-transparent",
                    }, className: "overflow-hidden", selectedKeys: selectedTableCells, selectionMode: "multiple", sortDescriptor: initialSortDescriptor, topContent: (0, jsx_runtime_1.jsx)(table_top_content_1.TableTopContent, { selectedTableCells: [] }), topContentPlacement: "outside", onSelectionChange: onSelectionChange }, { children: [(0, jsx_runtime_1.jsx)(react_1.TableHeader, __assign({ columns: columns }, { children: function (column) { return ((0, jsx_runtime_1.jsx)(react_1.TableColumn, __assign({ align: column.uid === "actions" ? "center" : "start" }, { children: column.name }), column.uid)); } })), (0, jsx_runtime_1.jsx)(react_1.TableBody, __assign({ isLoading: loading, emptyContent: "This table is empty.", items: mediaAssets, loadingContent: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Loading..." }) }, { children: function (item) {
                                return ((0, jsx_runtime_1.jsx)(react_1.TableRow, { children: function (columnKey) { return ((0, jsx_runtime_1.jsx)(react_1.TableCell, { children: (0, jsx_runtime_1.jsx)(tabel_cell_1.TableCellComponent, { columnRecord: item, columnKey: columnKey, renderCellViews: renderCellViews, rowActions: rowActions }) })); } }, item === null || item === void 0 ? void 0 : item._id));
                            } }))] }))] }))) })));
};
exports.default = MediaAssetsTablePage;
